<mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
<div class="loader-box-container">
    <div class="loader-box">
        <div class="left">
            <skeleton variant="rect"></skeleton>
        </div>
        <div class="right">
            <skeleton variant="text"></skeleton>
            <skeleton variant="text"></skeleton>
            <skeleton variant="text"></skeleton>
        </div>
    </div>
    <div class="loader-text" trans>Loading</div>
</div>
